import React, {Component} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/app';
import 'firebase/database';
import {EditorDialog} from '../editor-components';
import RoleOptions from './role-options';

/** @class UserEditor
  * A component for editing an existing user.
  * Name and role can be changed; email cannot,
  * as it is used as the unique identifier by the
  * authentication system.
  * @prop {Array} users - the list of users
  * @prop {show} boolean - if the dialog should be displayed
  * @prop {function} onExit - the function to invoke when closing the dialog
  */
export default class UserEditDialog extends Component {
  /** @constructor
    * Constructs a new UserEditDialog instance
    */
  constructor(props) {
    super(props);
    this.state = {
      name: props.user.name,
      role: props.user.role,
      email: props.user.email
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }
  /** @method componentWillReceiveProps
    * Responds to changing props (most likely
    * when a new user has been selected).
    */
  componentWillReceiveProps(props) {
    this.setState({
      name: props.user.name,
      role: props.user.role,
      email: props.user.email
    });
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @method handleSelect
    * Applies changes to the user state from a select input
    * @param {InputEvent} event - the triggering event
    */
  handleSelect(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value
    }, () => this.handleBlur());
  }
  /** @function handleBlur
    * Applies the current state to the database
    */
  handleBlur() {
    firebase.database().ref(`/users/${this.props.user.id}`).set(this.state);
  }
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <EditorDialog show={this.props.show} onExit={this.props.onExit}>
        <h3>Edit User</h3>
        <p className="info-panel">
          All changes are applied automatically.
        </p>
        <div className="input-group">
          <label htmlFor="name">Name</label>
          <input name="name" type="text"
            value={this.state.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}/>
        </div>
        <div className="input-group">
          <label htmlFor="email">Email</label>
          <input name="email" type="email"
            value={this.state.email}
            readOnly={true}/>
        </div>
        <div className="input-group">
          <label htmlFor="role">Role</label><br/>
          <select name="role"
            value={this.state.role}
            onChange={this.handleSelect}
          >
            <RoleOptions/>
          </select>
        </div>
      </EditorDialog>
    );
  }
}

UserEditDialog.propTypes = {
  user: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onExit: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/user-list/user-edit-dialog.js